import { render } from "./loading-overlay.vue?vue&type=template&id=6c77de7c&scoped=true"
const script = {}

import "./loading-overlay.vue?vue&type=style&index=0&id=6c77de7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c77de7c"]])

export default __exports__